export const RoPurchaseOrder = "Purchase Order";
export const ROPOLabel =  "Purchase Order";
export const NEW_PURCHASE_ORDER_LABEL = "New Purchase Order"
export const EDIT_PURCHASE_ORDER_LABEL = "Edit Purchase Order"
export const VIEW_PURCHASE_ORDER_LABEL = "View Purchase Order"
export const ADD_RATE_LABEL = "Add Rate"
export const TERMS_AND_CONDITIONS_LABEL = "Terms and Conditions"
export const EDIT_TERMS_LABEL = "Edit Terms"
export const SAVE_TERMS_LABEL = "Save Terms"
export const CANCEL_TERMS_LABEL = "Cancel"

export const DEFAULT_TERMS_AND_CONDITIONS = `1. PRICE BASIS- EXTRA
2. Delivery: IMMIDIATE
3. Payment Terms: 30 days credit
4. Packing Instruction you have to ensure that Material is securely packed and Fully Protected from any Loss/Damage/Pilferage during Transit any such Loss.
5. Rejection Rejected material will be Replace by you Free of Cost Immediately within 3 to 5 days. As per specification Mentioned In our PO. Failing which VEDU INFRASTRUCTURE PVT LTD will not be Responsible for any Loss, Damage OR Theft of this material if any.
6. Acceptance of order in case your Acceptance is not Received within 03 days of Receipt at this order it shall be Deemed that you have Accepted the Order Along with its Terms and Condition.
7. Taxes & Duties:Inclusive in the Purchase Order Amount.
8. Insurance : Not applicable.
9. Freight Charges: EXTRA AT ACTUAL
10.invoice MRP & Part MRP should be same
11.without MRP we will not accept the material.`
